import React from 'react'
import {
  FilterManagerChildProps,
  FilterType,
  FilterManager
} from './filter-manager'
import { MetadataFilter } from '../applications-grid'

interface ChildProps<TAggregationCategory extends string>
  extends FilterManagerChildProps<TAggregationCategory> {}

interface Props<TAggregationCategory extends string> {
  readonly filterType: FilterType
  readonly customMetadataSelections: MetadataFilter[]
  readonly children: (
    props: ChildProps<TAggregationCategory>
  ) => React.ReactNode
}

export function FlowmapStateManager<TAggregationCategory extends string>({
  filterType,
  customMetadataSelections,
  children
}: Props<TAggregationCategory>) {
  return (
    <FilterManager
      filterType={filterType}
      customMetadataSelections={customMetadataSelections}
    >
      {(filterManagerChildProps) => {
        return children({
          ...filterManagerChildProps
        })
      }}
    </FilterManager>
  )
}
